export const ONLINE_NOTIFICATION_DURATION = 20000; // 20sec
export const IS_OFFLINE_ENABLED = process.env.REACT_APP_FEATURE_FLAGS_OFFLINE_ENABLED === 'true';
export const CUSTOMERS_PRELOADING_MAX_LIMIT = 20;
export const LOCAL_DB_NAME = 'directOrders';
export const LOCAL_WORKBOX_EXPIRATION_DB_NAME = 'workbox-expiration';
export const LOCAL_WORKBOX_CACHE_ENTRIES_STORE = 'cache-entries';
export const LOCAL_CUSTOMERS_STORE = 'customers';
export const LOCAL_ORDERS_STORE = 'orders';
export const SORT_LOCAL_CUSTOMERS_DIRECTION = 'asc';
